import axiosInstance from './AxiosInstance';
export const getMerchantReport = (getData) => {
  return axiosInstance.get("reports/list", {
    params: getData,
  });
};

export const getMerchantSummary = (getData) => {
  return axiosInstance.get("reports/summary", {
    params: getData,
  });
};

export const postCreateReport = (getData) => {
  return axiosInstance.post("reports/create",getData);
};

export const downloadReport = (reportId) => {
  return axiosInstance.post("reports/download-file", reportId , {
    responseType: 'blob', // Critical: response is file
  });
}

